import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '@/pages/shared/base-query-auth';
import {
    runMutationOnce,
    runQueryOnce,
    runTableQuery,
    stripEmptyParams,
} from '@/pages/shared/rtk-query-helpers';

export const accountDetailsApi = createApi({
    reducerPath: 'accountDetailsApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getSiteList: builder.mutation({
            query: ({ accountId, filter, haveAnyManagerRole } = {}) => ({
                url: '/api/site/list',
                method: 'POST',
                body: { AccountId: accountId, ...filter, haveAnyManagerRole },
            }),
        }),
        getSystemDetails: builder.query({
            query: (id) => ({ url: `/api/systems/${id}`, method: 'GET' }),
            keepUnusedDataFor: 0,
        }),
        getSystemList: builder.mutation({
            query: ({ accountId, filter } = {}) => ({
                url: '/api/systems/list',
                method: 'POST',
                body: { AccountId: accountId, ...filter },
            }),
        }),
        canApplyAccountName: builder.query({
            query: ({ accountName, accountId }) => ({
                url: '/api/accounts/accountNameValid',
                method: 'GET',
                params: stripEmptyParams({ accountName, accountId }),
            }),
            keepUnusedDataFor: 0,
        }),
        getHistory: builder.mutation({
            query: (model) => ({ url: '/api/accounts/history', method: 'POST', body: model }),
        }),
        listSystems: builder.mutation({
            query: (accountId) => ({
                url: '/api/systems/listSystems',
                method: 'POST',
                body: accountId,
            }),
        }),
        saveSystem: builder.mutation({
            query: (model) => ({ url: '/api/systems/save', method: 'POST', body: model }),
        }),
        deleteSystem: builder.mutation({
            query: (id) => ({ url: `/api/systems/delete/${id}`, method: 'DELETE' }),
        }),
        restoreSystem: builder.mutation({
            query: (id) => ({ url: `/api/systems/restore/${id}`, method: 'POST' }),
        }),
        generateApiKey: builder.mutation({
            query: (id) => ({ url: `/api/systems/generate-api-key/${id}`, method: 'POST' }),
        }),
        rotateApiKey: builder.mutation({
            query: (id) => ({ url: `/api/systems/rotate-api-key/${id}`, method: 'POST' }),
        }),
    }),
});

export const runAccountDetailsQuery = (dispatch, endpointName, arg) =>
    runQueryOnce(dispatch, accountDetailsApi.endpoints[endpointName], arg);

export const runAccountDetailsMutation = (dispatch, endpointName, arg) =>
    runMutationOnce(dispatch, accountDetailsApi.endpoints[endpointName], arg);

export const runAccountHistoryTableQuery = (dispatch, requestData) =>
    runTableQuery(dispatch, accountDetailsApi.endpoints.getHistory, requestData);

export const runAccountSiteListTableQuery = (dispatch, requestData) =>
    runTableQuery(dispatch, accountDetailsApi.endpoints.getSiteList, requestData);

export const runAccountSystemListTableQuery = (dispatch, requestData) =>
    runTableQuery(dispatch, accountDetailsApi.endpoints.getSystemList, requestData);

export default accountDetailsApi;
